import { redo, undo } from 'prosemirror-history'
import { liftListItem, splitListItem } from 'prosemirror-schema-list'
import { sinkListItem } from './commands/sinkListItem'
import { schema } from './Schema'

export const mac = typeof navigator != 'undefined' ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false

export const buildKeymap = () => {
  const map: Record<string, Function> = {
    'Mod-z': undo,
    'Shift-Mod-z': redo,
    Enter: splitListItem(schema.nodes.list_item),
    'Shift-Tab': liftListItem(schema.nodes.list_item),
    Tab: sinkListItem(schema.nodes.list_item),
  }

  if (!mac) map['Mod-y'] = redo

  return map
}
